import React from "react";
import { Positions } from "../types";

export const PositionContext = React.createContext<Positions>("default");

export { POSITIONS_MAP } from "./constants";
export { usePosition } from "./hooks";
